module.exports = __webpack_public_path__ + "static/media/caret.78e6260e.svg";